// /forge/training — Training phase page.
//
// Wraps existing Training content (Stages 9-26 module funnel, progress cards,
// duration analysis) as the "Current Cohort" tab. Remaining tabs are
// placeholders for future per-cohort completion trend, AIS attendance
// breakdown, and module-level progression across cohorts.

import PhaseTabs, { PlaceholderTab } from "../../components/shared/PhaseTabs";
import TrainingContent from "./TrainingContent";

export default function Training() {
  return (
    <PhaseTabs
      eyebrow="FORGE · Training"
      title="Training"
      subtitle="Recruit school through module completion — cohort progression and readiness."
      tabs={[
        {
          key: "cohort",
          label: "Current Cohort",
          content: <TrainingContent />,
        },
        {
          key: "completion",
          label: "Completion & Attrition",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Cohort-over-cohort completion rates, drop-out timing, and re-cycle tracking. Pulls from dash_recruit_training history." />
          ),
        },
        {
          key: "ais",
          label: "AIS Attendance",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Applicant Information Session attendance by session — who attended, return-rate from interest submission to AIS, skip-rate by channel." />
          ),
        },
        {
          key: "modules",
          label: "Module Progression",
          placeholder: true,
          content: (
            <PlaceholderTab hint="Heatmap of module completion by cohort. Surfaces modules that consistently bottleneck recruits." />
          ),
        },
      ]}
    />
  );
}
